import Types from "./types";
import { parseLuxuryCarsCmsData } from "../../../utils/helpers/parse-luxury-cars-cms-data";
import { getMosaicCmsData } from "../../../../server/routes/mosaic-cms";

const ELITE_SLUG = "elite-homepage-desktop";

const setCmsData = (data) => ({
    type: Types.SET_CMS_DATA,
    data
});

const fetchLuxuryPageData = () => dispatch => {
    return new Promise((resolve, reject) => {
        getMosaicCmsData(ELITE_SLUG)
            .then(response => {
                dispatch(setCmsData(parseLuxuryCarsCmsData(response)));
                resolve();
            })
            .catch(() => {
                dispatch(setCmsData({}));
                reject();
            });
    });
};
export {
    setCmsData,
    fetchLuxuryPageData
};
